import { controversyRadar, focusPoints } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function ControversyFocus() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <SectionHead
          zone="分区 06"
          title="争议焦点拆解"
          desc="把话题拆成几个可量化的维度，数值反映的是公开讨论中的相对强度，不是定性评价。"
        />

        <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              {controversyRadar.map((axis, idx) => (
                <div key={axis.axis}>
                  <div className="mb-1.5 flex items-center justify-between">
                    <span className="font-label text-xs font-medium text-foreground-700 md:text-sm">{axis.axis}</span>
                    <span className="font-heading text-sm font-black text-foreground-950">{axis.score}</span>
                  </div>
                  <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      style={{ width: `${axis.score}%`, animationDelay: `${idx * 90}ms` }}
                      className={`grow-bar h-full rounded-full ${
                        axis.score >= 80 ? 'bg-primary-500' : 'bg-accent-500'
                      }`}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="h-full rounded-lg border-l-4 border-secondary-500 bg-secondary-50 p-5 md:p-6">
              <h4 className="flex items-center gap-2 font-heading text-base font-black text-secondary-950">
                <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
                当前焦点提示
              </h4>
              <ul className="mt-4 flex flex-col gap-3.5">
                {focusPoints.map((point) => (
                  <li key={point} className="flex items-start gap-2.5">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-500"></span>
                    <span className="font-body text-sm leading-relaxed text-foreground-700">{point}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 rounded-md bg-secondary-100 px-4 py-3">
                <p className="font-label text-[11px] leading-relaxed text-secondary-900">
                  提示：以上数值随讨论实时变动，仅作趋势参考，不构成任何结论。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}